// Síntese de áudio autônoma via Web Audio API e vibração háptica
// Funciona 100% offline, sem depender do carregamento de arquivos externos de som

class GymAudioFeedback {
  private ctx: AudioContext | null = null;

  private getContext(): AudioContext {
    if (!this.ctx) {
      const AudioCtxClass = window.AudioContext || (window as any).webkitAudioContext;
      this.ctx = new AudioCtxClass();
    }
    if (this.ctx.state === 'suspended') {
      this.ctx.resume();
    }
    return this.ctx;
  }

  /**
   * Beep suave para contagem regressiva (3, 2, 1)
   */
  playCountdownTick() {
    try {
      const ctx = this.getContext();
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();

      osc.type = 'sine';
      osc.frequency.setValueAtTime(880, ctx.currentTime); // Nota A5

      gain.gain.setValueAtTime(0.15, ctx.currentTime);
      gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.12);

      osc.connect(gain);
      gain.connect(ctx.destination);

      osc.start();
      osc.stop(ctx.currentTime + 0.12);

      if ('vibrate' in navigator) {
        navigator.vibrate(80);
      }
    } catch (e) {
      console.warn('Audio tick bloqueado ou não suportado:', e);
    }
  }

  /**
   * Alarme de fim de descanso - Sinal forte para iniciar a próxima série
   */
  playRestFinishedAlarm() {
    try {
      const ctx = this.getContext();
      const now = ctx.currentTime;

      // Primeiro beep alto
      const osc1 = ctx.createOscillator();
      const gain1 = ctx.createGain();
      osc1.type = 'sawtooth';
      osc1.frequency.setValueAtTime(1046.5, now); // C6
      gain1.gain.setValueAtTime(0.35, now);
      gain1.gain.exponentialRampToValueAtTime(0.01, now + 0.25);
      osc1.connect(gain1);
      gain1.connect(ctx.destination);
      osc1.start(now);
      osc1.stop(now + 0.25);

      // Segundo beep duplo de confirmação
      const osc2 = ctx.createOscillator();
      const gain2 = ctx.createGain();
      osc2.type = 'sawtooth';
      osc2.frequency.setValueAtTime(1318.5, now + 0.3); // E6
      gain2.gain.setValueAtTime(0.4, now + 0.3);
      gain2.gain.exponentialRampToValueAtTime(0.01, now + 0.65);
      osc2.connect(gain2);
      gain2.connect(ctx.destination);
      osc2.start(now + 0.3);
      osc2.stop(now + 0.65);

      // Padrão de vibração vibrante no smartphone (400ms vibra, 150ms pausa, 600ms vibra)
      if ('vibrate' in navigator) {
        navigator.vibrate([400, 150, 600]);
      }
    } catch (e) {
      console.warn('Audio alarme bloqueado:', e);
    }
  }
}

export const gymAudio = new GymAudioFeedback();
